import React from "react";
import { Pie } from "@ant-design/charts";
import { DATA } from "../../../myanfinviz";
import * as _ from "lodash";
export const TypeOfInvestmentPieChart = () => {
  var newData = _.groupBy(DATA, (r) => r["Type Of Investment"]);
  // newData = _.orderBy(newData, (r) => r.length, "desc");
  console.log("TypeOfInvestmentPieChart data before", newData);

  newData = _.mapValues(newData, (r) => {
    return { name: r[0]["Type Of Investment"], value: r.length };
  });
  newData = _.orderBy(newData, (r) => r.value, "desc");
  console.log("TypeOfInvestmentPieChart data", newData);

  var config = {
    appendPadding: 10,
    data: [...newData],
    angleField: "value",
    colorField: "name",
    radius: 0.9,
    label: {
      type: "outer",
      offset: "-30%",
      content: function content(_ref) {
        var percent = _ref.percent;
        return _ref.name + " ".concat((percent * 100).toFixed(2), "%");
      },
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    interactions: [{ type: "pie-legend-active" }, { type: "element-active" }],
  };
  return <Pie {...config} />;
};
